import type { Money } from "@/configurator/domain/models/types";

// Currency codes rendered as a symbol instead of the ISO code, to match the
// design ("36 290 Kč").
const CURRENCY_LABELS: Partial<Record<Money["currency"], string>> = {
  CZK: "Kč",
};

/**
 * Grouped amount without the currency, so the panel and the offer can style the
 * number and the currency separately.
 */
export function formatAmount(money: Money): string {
  try {
    const formatted = new Intl.NumberFormat("cs-CZ", {
      maximumFractionDigits: 0,
      minimumFractionDigits: 0,
    }).format(money.amount);
    // Czech grouping uses a narrow no-break space, which renders inconsistently
    // across host pages; a regular no-break space keeps the digits together.
    return formatted.replace(/\p{Zs}/gu, " ");
  } catch {
    return String(money.amount);
  }
}

export function formatCurrencyLabel(money: Money): string {
  return CURRENCY_LABELS[money.currency] ?? money.currency;
}
